<template>
  <div class="envizion-loader" :style="loaderStyle" role="status">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 230 100" :width="computedWidth" :height="computedHeight" aria-hidden="true" focusable="false">
      <!-- Right shape (filled) -->
      <path class="shape-right" d="M220.17,11.82v50.04c0,2.69-.9,5.18-2.42,7.16l-27.06,27.06s-.02.03-.03.04l-.8.8s-.03.02-.04.03c-2.1,1.89-4.87,3.04-7.91,3.04h-50.08c-3.26,0-6.22-1.32-8.36-3.47-2.14-2.14-3.46-5.09-3.46-8.36v-50.04c0-3.26,1.32-6.22,3.46-8.36l26.31-26.18.13-.14s.09-.09.14-.13C152.16,1.27,155.06,0,158.26,0h50.09c3.27,0,6.22,1.32,8.36,3.46,2.14,2.14,3.46,5.09,3.46,8.36Z"/>
      <!-- Left shape (outline) -->
      <path class="shape-left" d="M88.35,10c.63,0,1.05.29,1.29.53.24.24.53.66.53,1.29v50.04c0,.28-.06.54-.17.77l-26.36,26.36c-.07.07-.15.15-.22.22l-.39.39c-.32.26-.7.39-1.13.39H11.82c-.62,0-1.05-.29-1.29-.54-.24-.24-.53-.66-.53-1.29v-50.04c0-.63.3-1.05.52-1.27l26.31-26.18.1-.1.06-.07.02-.02c.24-.23.65-.51,1.26-.51h50.09M88.35,0h-50.09C35.06,0,32.16,1.27,30.04,3.33c-.04.04-.09.09-.14.13l-.13.14L3.46,29.78c-2.14,2.14-3.46,5.1-3.46,8.36v50.04c0,3.26,1.33,6.22,3.46,8.36,2.14,2.14,5.1,3.47,8.36,3.47h50.08c3.04,0,5.82-1.15,7.91-3.04.01-.01.02-.02.04-.03l.8-.8s.02-.03.03-.04l27.06-27.06c1.52-1.98,2.42-4.47,2.42-7.16V11.82c0-3.27-1.33-6.22-3.46-8.36C94.57,1.32,91.62,0,88.35,0h0Z"/>
    </svg>
    <span class="envizion-loader__sr-only">{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'EnvizionLoader',
  props: {
    size: {
      type: [Number, String],
      default: 50,
    },
    color: {
      type: String,
      default: '#03624c',
    },
    label: {
      type: String,
      default: 'Loading',
    },
  },
  computed: {
    numericSize() {
      return parseInt(this.size, 10);
    },
    computedWidth() {
      // SVG viewBox is 230x100, so width = size * 2.3
      return Math.round(this.numericSize * 2.3);
    },
    computedHeight() {
      return this.numericSize;
    },
    loaderStyle() {
      return {
        '--loader-color': this.color,
        width: this.computedWidth + 'px',
        height: this.numericSize + 'px',
      };
    },
  },
};
</script>

<style scoped>
.envizion-loader {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Visually hidden, but announced by screen readers (role="status" live region). */
.envizion-loader__sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.shape-right,
.shape-left {
  fill: var(--loader-color, #03624c);
}

.shape-right {
  animation: pulse-right 1.4s ease-in-out infinite;
  transform-origin: 165px 50px;
}

.shape-left {
  animation: pulse-left 1.4s ease-in-out infinite;
  transform-origin: 50px 50px;
}

@keyframes pulse-right {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.3; transform: scale(0.88); }
}

@keyframes pulse-left {
  0%, 100% { opacity: 0.3; transform: scale(0.88); }
  50% { opacity: 1; transform: scale(1); }
}
</style>
